// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 9351 ? "commons" : chunkId) + "." + {"1858":"a5edf76c","5098":"b30c5d2c","9351":"0a93ddcf"}[chunkId] + ".chunk.css";
};